"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createAppolloClientDevelopment = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/createAppolloClientDevelopment"));
var _createAppolloClientVersion = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/createAppolloClientVersion3"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const createAppolloClient = process.env.NODE_ENV === "production" ? _createAppolloClientVersion.default : _createAppolloClientDevelopment.default;
var _default = exports.default = createAppolloClient;